import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    standalone: false,
    selector: 'ep-address-lookup-select-dialog',
    templateUrl: './address-lookup-select-dialog.component.html'
})
export class AddressLookupSelectDialogComponent {
    @Input() enteredAddress: any;
    @Input() addresses: any[];

    model: any = {
        addressLookupMode: 'UPDATE'
    };

    constructor(private activeModal: NgbActiveModal) {
        if (this.addresses) {
            this.addresses.map((adr) => {
                adr.Selected = '';
                return adr;
            });

            this.addresses[0].Selected = '>>>';
        }
    }

    public cancelSelection() {
        this.activeModal.close();
    }

    public validationOverride() {
        this.activeModal.close({ Event: 'O', Address: this.enteredAddress });
    }

    public acceptValidated(address: any) {
        this.activeModal.close({ Event: 'V', Address: address });
    }

    public getAddressDisplay(address: any) {
        let display: any = '';
        let addressCopy = {
            Address_Line_1: address.Address_Line_1 ? address.Address_Line_1 : '',
            Address_Line_2: address.Address_Line_2 ? address.Address_Line_2 : '',
            Address_Line_3: address.Address_Line_3 ? address.Address_Line_3 : '',
            City: address.City ? address.City : '',
            State: address.State ? address.State : '',
            Zip: address.Zip ? address.Zip : '',
            County: address.County ? address.County : '',
            Country: address.Country ? address.Country : '',
            Latitude: address.Latitude ? address.Latitude : '',
            Longitude: address.Longitude ? address.Longitude : ''
        };

        // eslint-disable-next-line max-len
        display = `{${addressCopy.Address_Line_1} ${addressCopy.Address_Line_2} ${addressCopy.Address_Line_3}, ${addressCopy.City}, ${address.State} ${addressCopy.Zip}, ${addressCopy.County}, ${addressCopy.Country}`;

        return display;
    }
}
